import { Box, Button, Code, Flex, IconButton, ListItem, Text, UnorderedList, useDisclosure } from '@chakra-ui/react'
import { AddInterval } from './AddInterval'
import { IntervalWrapper } from './MultiDayInterval/styled'
import { FiX } from 'react-icons/fi'
import { capitalizeString } from '../../../../fix-search/utils'
import { YamlView } from '../YamlView'

const buildIntervalPreview = (interval) => {
    const intervalType = Object.keys(interval)[0]
    if (intervalType === '@StandardSessionScheduleCfg') {
        return `${interval['@StandardSessionScheduleCfg'].dayOfWeekList.map((d) => capitalizeString(d['@DayOfWeek'].toString().toLowerCase())).join(', ')} 
            ${interval['@StandardSessionScheduleCfg'].startTime['@Time']} - 
            ${interval['@StandardSessionScheduleCfg'].endTime['@Time']}
            (${interval['@StandardSessionScheduleCfg'].timeZoneId})`
    }

    if (intervalType === '@ArbitrarySessionCfg') {
        return <UnorderedList>
            {interval['@ArbitrarySessionCfg'].schedulePoints
                    .reduce(function(result, value, index, array) {
                        if (index % 2 === 0)
                            result.push(array.slice(index, index + 2));
                        return result;
                    }, [])
                    .map((interval) => buildPeriodPreview(interval[0], interval[1]))
                    .map((interval) => <ListItem>{interval}</ListItem>)}
        </UnorderedList>
    }

    if (intervalType === '@ManualSessionScheduleCfg') {
        return <>Manual activation, initial state is <Code>{interval['@ManualSessionScheduleCfg'].initialState['@ManualSessionSchedule']}</Code></>
    }
    
    return <YamlView
        object={interval}
        codeStyle={{
            minWidth: 'initial',
            width: '100%'
        }}
    />
}

const extractSchedulePoint = (point) => {
    const typeKey = Object.keys(point).find(k => k.startsWith('@'))
    const data = typeKey ? point[typeKey] : point
    const day = data.day?.['@DayOfWeek'] ?? data.day
    const time = data.time?.['@Time'] ?? data.time
    return { day, time, zoneId: data.zoneId }
}

export const buildPeriodPreview = (start, stop) => {
    const s = extractSchedulePoint(start)
    const e = extractSchedulePoint(stop)
    return `${capitalizeString(s.day?.toLowerCase())} ${s.time} (${s.zoneId}) - ${capitalizeString(e.day?.toLowerCase())} ${e.time} (${e.zoneId})`
}

export const ScheduleSessionConfig = ({
    interval,
    handleSaveSchedule,
    isDisabled
}) => {
    const { onOpen: onAddIntervalOpen, onClose: onAddIntervalClose, isOpen: isAddIntervalOpen } = useDisclosure()

    const handleAddInterval = (interval) => {
        handleSaveSchedule(interval)
        onAddIntervalClose()
    }

    const handleDeleteInterval = () => {
        handleSaveSchedule(null)
    }

    const isIntervalEmpty = () => (!interval || Object.keys(interval[Object.keys(interval)[0]]).length === 0)

    return (
        <Box sx={{ width: '100%', height: '100%' }} display="flex" flexDir="column">
            {isAddIntervalOpen ? (
                <AddInterval onAddInterval={handleAddInterval} />
            ) : (
                <Box>
                    <Box margin={4} display="flex" flexDir="column" justifyContent="center">
                        {!isIntervalEmpty() && (
                            <Flex w="100%" alignItems="center"
                            justifyContent='space-around'>
                                <IntervalWrapper>{buildIntervalPreview(interval)}</IntervalWrapper>
                                <IconButton
                                    isRound
                                    marginLeft={3}
                                    size="xs"
                                    isDisabled={isDisabled}
                                    onClick={handleDeleteInterval}
                                    icon={<FiX />}
                                />
                            </Flex>
                        )}
                        {isIntervalEmpty() && (
                            isDisabled ? <Text align='center'>No Session Schedule defined</Text> :
                            <Button
                                alignSelf="center"
                                onClick={onAddIntervalOpen}
                            >Add Session Schedule</Button>
                        )}
                    </Box>
                </Box>
            )}
        </Box>
    )
}
